// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__1M8uE","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__49B-x"};